module.exports = __webpack_public_path__ + "img/rebuild_liao_mob2.17645907.jpg";